module.exports = __webpack_public_path__ + "static/img/discover.6bafbf26.png";